// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout-footer {
  padding: 10px 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: #fff;
}
.layout-footer .bdp-align-left {
  float: left;
  text-align: left;
}
.layout-footer .bdp-align-right {
  float: right;
  text-align: right;
}

@media only screen and (max-width: 870px) {
  .layout-footer div#timeline-wrap {
    margin-bottom: 5px;
  }
  .layout-footer div#timeline-wrap .bdp-footer-label {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/air/modules/common/component/footer/app.footer.component.scss"],"names":[],"mappings":"AAAA;EAEI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AAAJ;AAEI;EACI,WAAA;EACA,gBAAA;AAAR;AAGI;EACI,YAAA;EACA,iBAAA;AADR;;AAKA;EACI;IACI,kBAAA;EAFN;EAIM;IACI,aAAA;EAFV;AACF","sourcesContent":[".layout-footer {\n\n    padding: 10px 15px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    background: #fff;\n\n    .bdp-align-left {\n        float: left;\n        text-align: left;\n    }\n\n    .bdp-align-right {\n        float: right;\n        text-align: right;\n    }\n}\n\n@media only screen and (max-width: 870px) {\n    .layout-footer div#timeline-wrap {\n        margin-bottom: 5px;\n\n        .bdp-footer-label {\n            display: none;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
